import { stripHtml } from '~utils/htmlUtils'

function toCsvValue(value: string | number): string {
  const text = stripHtml(String(value)).replace(/\[([^\]]+)\]\(([^)]+)\)/g, '=HYPERLINK("$2","$1")')
  return text.includes(',') || text.includes('"') || text.includes('\n')
    ? `"${text.replace(/"/g, '""')}"`
    : text
}

export function downloadCsv(
  columns: string[],
  rows: (string | number)[][],
  filename: string,
): void {
  const lines = [
    columns.map(toCsvValue).join(','),
    ...rows.map((row) => row.map(toCsvValue).join(',')),
  ]
  const blob = new Blob([lines.join('\n')], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  link.click()
  URL.revokeObjectURL(url)
}
